var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React from "react";
import PropTypes from "prop-types";
import { Box } from "@twilio-paste/box";
import { Text } from "@twilio-paste/text";
import { SiblingBox } from "@twilio-paste/sibling-box";
import { Label } from "@twilio-paste/label";
import { HelpText } from "@twilio-paste/help-text";
var BaseRadioCheckboxControl = React.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      disabled,
      element = "BASE_RADIO_CHECKBOX_CONTROL"
    } = _b,
    props = __objRest(_b, ["children", "disabled", "element"]);
  return React.createElement(SiblingBox, __spreadValues({
    as: "span",
    ref,
    display: "flex",
    element,
    backgroundColor: "colorBackgroundBody",
    borderColor: "colorBorder",
    borderStyle: "solid",
    borderWidth: "borderWidth10",
    height: "sizeSquare50",
    marginX: "space20",
    marginY: "space10",
    width: "sizeSquare50",
    color: "colorTextWeakest",
    _hoverSibling: {
      borderColor: "colorBorderPrimaryStronger",
      color: "colorTextWeakest"
    },
    _focusSibling: {
      borderColor: "colorBorderPrimaryStronger",
      boxShadow: "shadowFocus",
      color: "colorTextWeakest"
    },
    _activeSibling: disabled ? void 0 : {
      borderColor: "colorBorderPrimaryStronger",
      backgroundColor: "colorBackgroundPrimaryStronger",
      color: "colorTextWeakest"
    },
    _checkedSibling: {
      borderColor: "colorBorderPrimary",
      backgroundColor: "colorBackgroundPrimary",
      color: "colorTextInverse"
    },
    _disabledSibling: {
      borderColor: "colorBorderWeaker"
    },
    _invalidSibling: {
      borderColor: "colorBorderError"
    },
    _invalidAndHoverSibling: {
      borderColor: "colorBorderErrorStronger"
    },
    _invalidAndDisabledSibling: {
      borderColor: "colorBorderWeaker"
    },
    _checkedAndHoverSibling: {
      borderColor: "colorBorderPrimaryStronger",
      backgroundColor: "colorBackgroundPrimaryStronger",
      color: "colorTextWeakest"
    },
    _checkedAndFocusSibling: {
      borderColor: "colorBorderPrimaryStronger",
      backgroundColor: "colorBackgroundPrimaryStronger",
      color: "colorTextWeakest"
    },
    _checkedAndActiveSibling: disabled ? void 0 : {
      borderColor: "colorBorderPrimaryStronger",
      backgroundColor: "colorBackgroundPrimaryStronger"
    },
    _checkedAndDisabledSibling: {
      borderColor: "colorBorderWeaker",
      backgroundColor: "colorBackgroundStrong",
      color: "colorTextWeakest"
    },
    _checkedAndInvalidSibling: {
      borderColor: "colorBorderError",
      backgroundColor: "colorBackgroundError",
      color: "colorTextInverse"
    },
    _checkedAndInvalidAndHoverSibling: {
      borderColor: "colorBorderErrorStronger",
      backgroundColor: "colorBackgroundErrorStronger"
    },
    _checkedAndInvalidAndDisabledSibling: {
      borderColor: "colorBorderWeaker",
      backgroundColor: "colorBackgroundStrong",
      color: "colorTextWeakest"
    }
  }, props), children);
});
BaseRadioCheckboxControl.displayName = "BaseRadioCheckboxControl";
var BaseRadioCheckboxLabel = React.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children
    } = _b,
    props = __objRest(_b, ["children"]);
  return React.createElement(Label, __spreadProps(__spreadValues({}, props), {
    marginBottom: "space0",
    ref
  }), React.createElement(Box, {
    as: "span",
    display: "flex"
  }, children));
});
BaseRadioCheckboxLabel.displayName = "BaseRadioCheckboxLabel";
var BaseRadioCheckboxLabelText = React.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element = "BASE_RADIO_CHECKBOX_LABEL_TEXT"
    } = _b,
    props = __objRest(_b, ["children", "element"]);
  return React.createElement(Text, __spreadValues({
    as: "span",
    color: "currentColor",
    marginLeft: "space20",
    fontWeight: "fontWeightMedium",
    element,
    ref
  }, props), children);
});
BaseRadioCheckboxLabelText.displayName = "BaseRadioCheckboxLabelText";
var BaseRadioCheckboxHelpText = React.forwardRef((_ref, ref) => {
  let {
    children,
    helpTextId,
    element = "BASE_RADIO_CHECKBOX_HELP_TEXT_WRAPPER"
  } = _ref;
  return React.createElement(Box, {
    as: "span",
    display: "block",
    element,
    marginLeft: "space80",
    ref
  }, React.createElement(HelpText, {
    id: helpTextId,
    marginTop: "space0"
  }, children));
});
BaseRadioCheckboxHelpText.displayName = "BaseRadioCheckboxHelpText";
BaseRadioCheckboxHelpText.propTypes = {
  children: PropTypes.node.isRequired,
  helpTextId: PropTypes.string.isRequired,
  element: PropTypes.string
};
export { BaseRadioCheckboxControl, BaseRadioCheckboxHelpText, BaseRadioCheckboxLabel, BaseRadioCheckboxLabelText };